/**
 *
 * 使用方法
 * import { getUrlQuery } from "@/utils/handleUrl.js";
 * 
 * getUrlQuery() {
      return getUrlQuery(date);
   },
 */

/**
 * @description 获取url？后面的参数  paramName：要获取的参数名
 * @param paramName
 * @returns {paramName}
 */

 export function getUrlQuery(paramName) {
    var url = document.location.toString();
    var arrObj = url.split("?");
    if (arrObj.length > 1) {
      var arrPara = arrObj[1].split("&");
      var arr;
      for (var i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split("=");
  
        if (arr != null && arr[0] === paramName) {
          return arr[1];
        }
      }
      return "";
    } else {
      return "";
    }
  }
  

  /**
     *  数组排序从小到大     */
   export function maxSorting (arr, type) {
    // 创建每次循环存储最大值得变量
    var max // 遍历数组，默认arr中的某一个元素为最大值，进行逐一比较
    for (var i = 0; i < arr.length; i++) {
      // 外层循环一次，就拿arr[i] 和 内层循环arr.legend次的 arr[j] 做对比
      for (var j = i; j < arr.length; j++) {
        if (arr[i][type] > arr[j][type]) {
          // 如果arr[j]大就把此时的值赋值给最大值变量max
          max = arr[j]
          arr[j] = arr[i]
          arr[i] = max
        }
      }
    }
    return arr
  }
  /**
   *  数组排序从大到小
   */
   export function minSorting (arr, type) {
    // 创建每次循环存储最小值得变量
    var min // 遍历数组，默认arr中的某一个元素为最小值，进行逐一比较
    for (var i = 0; i < arr.length; i++) {
      // 外层循环一次，就拿arr[i] 和 内层循环arr.legend次的 arr[j] 做对比
      for (var j = i; j < arr.length; j++) {
        if (arr[i][type] < arr[j][type]) {
          // 如果arr[j]小就把此时的值赋值给最小值变量min
          min = arr[j]
          arr[j] = arr[i]
          arr[i] = min
        }
      }
    }
    return arr
  }